<template>
  <div class="at-entry">
    <aside class="at-entry__visual">
      <span class="at-entry__kite at-entry__kite--a" />
      <span class="at-entry__kite at-entry__kite--b" />
      <svg class="at-entry__emblem" viewBox="0 0 368.86 368.86" aria-hidden="true">
        <path fill="#fffced" d="M102.22,368.27l86.79-36.18c4.33-1.81,7.68-5.39,9.18-9.83l30.18-89.06c2.04-6.03-3.98-11.66-9.86-9.21l-86.79,36.18c-4.33,1.81-7.68,5.39-9.18,9.83l-30.18,89.06c-2.04,6.03,3.98,11.66,9.86,9.21Z"/>
        <path fill="#fffced" d="M.59,102.22l36.18,86.79c1.81,4.33,5.39,7.68,9.83,9.18l89.06,30.18c6.03,2.04,11.66-3.98,9.21-9.86l-36.18-86.79c-1.81-4.33-5.39-7.68-9.83-9.18L9.79,92.36c-6.03-2.04-11.66,3.98-9.21,9.86Z"/>
        <path fill="#fffced" d="M266.63.59l-86.79,36.18c-4.33,1.81-7.68,5.39-9.18,9.83l-30.18,89.06c-2.04,6.03,3.98,11.66,9.86,9.21l86.79-36.18c4.33-1.81,7.68-5.39,9.18-9.83l30.18-89.06c2.04-6.03-3.98-11.66-9.86-9.21Z"/>
        <path fill="#fffced" d="M368.27,266.63l-36.18-86.79c-1.81-4.33-5.39-7.68-9.83-9.18l-89.06-30.18c-6.03-2.04-11.66,3.98-9.21,9.86l36.18,86.79c1.81,4.33,5.39,7.68,9.83,9.18l89.06,30.18c6.03,2.04,11.66-3.98,9.21-9.86Z"/>
      </svg>
      <span class="at-entry__vlabel">Cap sur la santé et le bien-être au travail</span>
    </aside>

    <main class="at-entry__panel">
      <div class="at-entry__brand">
        <svg class="at-entry__mark" viewBox="0 0 368.86 368.86" aria-hidden="true">
          <path fill="#1c4d4d" d="M102.22,368.27l86.79-36.18c4.33-1.81,7.68-5.39,9.18-9.83l30.18-89.06c2.04-6.03-3.98-11.66-9.86-9.21l-86.79,36.18c-4.33,1.81-7.68,5.39-9.18,9.83l-30.18,89.06c-2.04,6.03,3.98,11.66,9.86,9.21Z"/>
          <path fill="#1c4d4d" d="M.59,102.22l36.18,86.79c1.81,4.33,5.39,7.68,9.83,9.18l89.06,30.18c6.03,2.04,11.66-3.98,9.21-9.86l-36.18-86.79c-1.81-4.33-5.39-7.68-9.83-9.18L9.79,92.36c-6.03-2.04-11.66,3.98-9.21,9.86Z"/>
          <path fill="#1c4d4d" d="M266.63.59l-86.79,36.18c-4.33,1.81-7.68,5.39-9.18,9.83l-30.18,89.06c-2.04,6.03,3.98,11.66,9.86,9.21l86.79-36.18c4.33-1.81,7.68-5.39,9.18-9.83l30.18-89.06c2.04-6.03-3.98-11.66-9.86-9.21Z"/>
          <path fill="#1c4d4d" d="M368.27,266.63l-36.18-86.79c-1.81-4.33-5.39-7.68-9.83-9.18l-89.06-30.18c-6.03-2.04-11.66,3.98-9.21,9.86l36.18,86.79c1.81,4.33,5.39,7.68,9.83,9.18l89.06,30.18c6.03,2.04,11.66-3.98,9.21-9.86Z"/>
        </svg>
        <span class="at-entry__word">Ataviti</span>
        <span class="at-entry__tag">Daisy</span>
      </div>

      <span class="at-entry__badge">Bienvenue</span>
      <h1 class="at-entry__title">Prêt quand vous l'êtes.</h1>
      <p class="at-entry__lead">Connectez-vous pour retrouver votre espace Daisy.</p>

      <b-button
        class="at-entry__cta"
        :disabled="loginPrompted"
        @click="startApp()"
      >
        <span v-if="!loginPrompted">Me connecter<span class="at-entry__arr">→</span></span>
        <span v-else class="at-entry__cta-loading"><b-spinner small /> Connexion…</span>
      </b-button>
    </main>
  </div>
</template>

<script>
/* eslint-disable global-require */
import {
  BLink, BButton, BImg, BSpinner,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import store from '@/store/index'

export default {
  components: {
    VuexyLogo,
    BLink,
    BButton,
    BImg,
    BSpinner
  },
  data() {
    return {
      loginPrompted: false,
      downImg: require('@/assets/images/pages/coming-soon.svg'),
    }
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/coming-soon-dark.svg')
        return this.downImg
      }
      return this.downImg
    },
  },
  methods: {
    startApp() {
      try {
        this.loginPrompted = true
        if (!this.$authService.willTokenExpire()) {
          this.$router.push({ name: 'home' })
        } else {
          this.$authService
            .login()
            .then(
                () => {}, 
                (error) => {
                  this.$http.ressifnet.utils.Logger(error.stack, 'error')
                  this.loginPrompted = false
                  if (error.message === 'Network Error') {
                        this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Erreur de configuration',
                            icon: 'WifiOffIcon',
                            text: 'Impossible de contacter le serveur d\'identité',
                            variant: 'danger',
                        },
                        },
                        {
                        timeout: 800000,
                        position: 'top-center',
                  })
                  } else {
                    this.$toast({
                        component: ToastificationContent,
                        props: {
                            title: 'Notification',
                            icon: 'XIcon',
                            text: error.message,
                            variant: 'danger',
                        },
                        },
                        {
                        timeout: 800000,
                        position: 'top-center',
                        })
                  }
            })
        }
      } catch (error) {
        this.loginPrompted = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.at-entry {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: grid;
  grid-template-columns: 0.92fr 1.08fr;
  font-family: 'Figtree', system-ui, -apple-system, sans-serif;
  background: #fffced;
  color: #1c4d4d;
  overflow: hidden;
}
.at-entry__visual {
  position: relative;
  background: #1c4d4d;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.at-entry__kite {
  position: absolute;
  background: #fcf5a6;
  pointer-events: none;
  border-radius: 44% 56% 50% 50% / 56% 46% 54% 44%;
}
.at-entry__kite--a { width: 46vmin; height: 60vmin; left: -12vmin; top: -12vmin; transform: rotate(18deg); opacity: .16; }
.at-entry__kite--b { width: 20vmin; height: 28vmin; right: -4vmin; bottom: 8vmin; transform: rotate(-14deg); opacity: .10; }
.at-entry__emblem {
  width: min(210px, 24vmin);
  height: auto;
  position: relative;
  z-index: 1;
  transform-origin: 50% 50%;
  animation: at-spin 12s linear infinite;
}
.at-entry__vlabel {
  position: absolute;
  bottom: 28px;
  left: 28px;
  z-index: 1;
  color: rgba(255, 252, 237, .82);
  font-size: .74rem;
  letter-spacing: .12em;
  text-transform: uppercase;
}
.at-entry__panel {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  padding: clamp(34px, 5vw, 72px);
}
.at-entry__brand { display: flex; align-items: center; gap: 11px; margin-bottom: 8px; }
.at-entry__mark { width: 30px; height: 30px; }
.at-entry__word { font-family: 'Fraunces', Georgia, serif; font-size: 1.45rem; font-weight: 600; color: #1c4d4d; }
.at-entry__tag {
  font-size: .66rem; font-weight: 600; letter-spacing: .14em; text-transform: uppercase;
  color: rgba(28, 77, 77, .6); border-left: 1px solid rgba(28, 77, 77, .4); padding-left: 9px;
}
.at-entry__badge {
  align-self: flex-start;
  background: #fcf5a6;
  color: #1c4d4d;
  font-weight: 700;
  font-size: .7rem;
  letter-spacing: .18em;
  text-transform: uppercase;
  padding: 9px 18px 9px 16px;
  clip-path: polygon(0 0, 100% 0, 100% 64%, calc(100% - 13px) 100%, 0 100%);
}
.at-entry__title {
  font-family: 'Fraunces', Georgia, 'Times New Roman', serif;
  font-weight: 500;
  font-size: clamp(2.3rem, 4.4vw, 3.4rem);
  line-height: 1.05;
  letter-spacing: -.5px;
  margin: 0;
  color: #1c4d4d;
}
.at-entry__lead {
  color: rgba(28, 77, 77, .66);
  font-size: 1.06rem;
  line-height: 1.55;
  margin: 0;
  max-width: 42ch;
}
.at-entry__cta {
  align-self: flex-start;
  margin-top: 8px;
  background: #1c4d4d !important;
  border: none !important;
  color: #fffced !important;
  font-family: 'Figtree', sans-serif;
  font-weight: 600;
  font-size: 1rem !important;
  border-radius: 999px !important;
  padding: 14px 30px !important;
  box-shadow: 0 14px 30px -16px rgba(28, 77, 77, .7);
  transition: transform .18s ease, box-shadow .25s ease;
}
.at-entry__cta:hover:not(:disabled) { transform: translateY(-2px); }
.at-entry__cta:disabled { opacity: .75; cursor: default; }
.at-entry__arr { display: inline-block; margin-left: 10px; transition: transform .25s ease; }
.at-entry__cta:hover .at-entry__arr { transform: translateX(4px); }
.at-entry__cta-loading { display: inline-flex; align-items: center; gap: 10px; }

@keyframes at-spin { to { transform: rotate(360deg); } }

@media (max-width: 820px) {
  .at-entry { grid-template-columns: 1fr; grid-template-rows: 30% 70%; }
  .at-entry__vlabel { display: none; }
}
@media (prefers-reduced-motion: reduce) {
  .at-entry__emblem { animation: none; }
}
</style>
